<template>
  <div class="chart_area">
    <div class="price_area">
      <div class="code_name">{{codeName}}</div>
      <div class="quote">
        <div class="price" :class="[{'red':product.className == 'red'},{'green':product.className == 'green'}]">{{product.price}}</div>
        <div class="ampulte"  :class="[{'red':product.className == 'red'},{'green':product.className == 'green'}]">
            <span>{{product.val}}</span>
        </div>
      </div>
    </div>
    <div class="time_choice">
      <ul>
        <li
          :class="[index == activeIndex ?'active':'']"
          v-for="(item,index) in timeArr"
          @click="changeCharts(item.label,index)"
          :key="index"
        >{{item.time}}</li>
      </ul>
      <div ref="chartMin" id="chartMin" style="width:6rem;height:5rem;margin:0 auto;top:-.5rem;position:relative"></div>
     </div>
  </div>
</template>

<script>
import Utils from "@/assets/commonjs/tool";
import { snow } from 'color-name';
// 引入 ECharts 主模块
var echarts = require('echarts/lib/echarts');
require('echarts/lib/chart/line');
require('echarts/lib/chart/candlestick');
// // 引入提示框和标题组件
require('echarts/lib/component/tooltip');
export default {
  props: ["code"],
  data() {
    return {
      timeArr: [
         {
          time: '分时图',
          label: "time"
        },
        {
          time: '5分',
          label: "5min"
        },
        {
          time: '10分',
          label: "15min"
        },
        {
          time: '30分',
          label: "30min"
        },
        {
          time: '1小时',
          label: "1hour"
        },
        {
          time: '周K',
          label: "week"
        }
      ],
      activeIndex: 0,
      product:"",
      codeName:''
     
    };
  },
  beforeUpdate(){
    this.$nextTick(function(){
      if(this.activeIndex == 0){
        this.getTimeline();
      }else{
        return
      }
    })
  },
  methods: {
    initCharts(data, type) {
        
      var myCharts = echarts.init(document.getElementById('chartMin'));
      if (type == "fenshi") {
       
        myCharts.setOption({
          
          tooltip: {
            //弹框指示器
            trigger: "axis",
            axisPointer: {
              type: "cross"
            },
            showContent:false
          },
          grid:{
                    x:45,
                },
          action:{
             hideTip:true
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: data.times,
            axisLabel: {
              //label文字设置
              color: "#9b9da9",
              fontSize: 10
            },
            splitLine: {
              show: true
            }
          },
          yAxis: {
            type: "value",
            scale: true,
            splitNumber: 3,
           
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#ddd"],
                width: 1,
                type: "solid"
              }
            }
          },
          series: [
            {
              type: "line",
              data: data.price,
              smooth: true,

              sampling: "average",
              itemStyle: {
                normal: {
                  color: "#a7ddf6", //改变折线点的颜色
                  lineStyle: {
                    color: "#a7ddf6", //改变折线颜色
                    width: 1,
                    type: "dash"
                  }
                }
              },
              areaStyle: {
                normal: {
                  color: "rgba(0,150,220,.2)" //改变区域颜色
                }
              }
            }
          ]
        });
      } else {
         var kpEn = "开盘价"
        var zdEn = "最低价"
        var spEn = "收盘价"
        var zgEn = "最高价"
        myCharts.setOption({
          tooltip: {
            //弹框指示器
            trigger: "axis",
            axisPointer: {
              type: "cross"
            },
            showContent:true,
            position: 'inside',
            formatter:function(params){
            var obj = {}
            if (params[0].value[0] !== undefined) {// 防止放上去提示undefined
              obj = {
                name: params[0].name,
                start: params[0].value[1],
                close: params[0].value[2],
                low: params[0].value[3],
                height: params[0].value[4],
              }
            } 
          var res = obj.name
          res += '<br/>  '+"<div>" + kpEn + ' : ' + obj.start + "</div>"+'  ' + zdEn + '  : ' + obj.height 
          res += '<br/>  '+"<div>" + spEn + ' : ' + obj.close + "</div>"+'  ' + zgEn + ': ' + obj.low
         
          return res
            }
          },
          xAxis: {
            type: "category",
            data: data.times,
            splitLine: { show: false },
            boundaryGap: true,
            
          },
          yAxis: {
            axisLine: { lineStyle: { color: "#8392A5" } },
            splitLine: { show: false }
          },
          series: [
            {
              type: "candlestick",
              data: data.datas,
              itemStyle: {
                color: "#FD1050",
                color0: "#0CF49B",
                borderColor: "#FD1050",
                borderColor0: "#0CF49B"
              }
            }
          ]
        });
      }
    },
    getTimeline() {
      let data = {
        symbol: this.code,
        companyCode: 72
      };
      this.$api.answerList.getTimeline(data).then(res => {
        if (res.data.code == 0) {
          var sharingplanData = this.splitData(res.data.result);
          this.initCharts(sharingplanData, "fenshi");
        }
      });
    },
    splitData(data) {
      var price = [],
        times = [];
      for (let i in data) {
        price.push(data[i].price);
        times.push(Utils.formatDate(new Date(data[i].time * 1000), "hh:mm"));
      }
      return {
        price,
        times
      };
    },
    splitKData(data) {
      var datas = [],
        times = [];

      for (let i in data) {
        datas[i] = [data[i].begin, data[i].end, data[i].low, data[i].high];
        times.push(
          Utils.formatDate(new Date(Number(data[i].time * 1000)), "MM/dd hh:mm")
        );
      }
      return { datas: datas, times: times };
    },
    changeCharts(label, index) {
      this.activeIndex = index;
      if (label == "time") {
        this.getTimeline();
      } else {
        this.getKline(label);
      }
    },
    getKline(label) {
      let data = {
        symbol: this.code,
        company: 1,
        ktype: label,
        num: 30
      };
      this.$api.answerList.getKline(data).then(res => {
        if (res.data.code == 0) {
          var sharingplanData = this.splitKData(res.data.result);

          this.initCharts(sharingplanData, "kline");
        }
      });
    },
    percent: function(value) {
      if (!value) return "";
      value = Number(value * 100).toFixed(2);
      value += "%";
      return value;
    },
    getProduceData(code) {
      var productPramas;
      this.$api.strageList.getProductDataSingle(code).then(res => {
        let ampClass, ampValue, ampName, ampPrice,ampSymbol;
        
        if (res.data.data.length != 0) {
          let data = res.data.data[0];
           this.codeName = data.name
           
              if (data.amplitude > 0) {
                ampClass = "red";
              } else {
                ampClass = "green";
              }
            
            if (data.amplitude) {
              // ampClass = data[i].amplitude > 0 ? "red" : "green";
              ampValue = this.percent(data.amplitude);
            } else if (data.amplitude == 0) {
              ampClass = "";
              ampValue = 0;
            }
            ampName = data.name;
            ampPrice = data.price;
            ampSymbol = data.symbol;
            productPramas = {
              className: ampClass,
              val: ampValue,
              name: ampName,
              price: ampPrice,
              symbol:ampSymbol
            };
            this.product = productPramas;
          }
        
      });
    },
  },
  mounted() {
       this.getTimeline();
       this.getProduceData(this.code)
       
  },
 
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/mixin";
.chart_area {
  width: 6.9rem;
  height: 6.5rem;
  background: #fff;
  margin: 0 auto;
  padding: 0.2rem;
}
.code_name {
  font-size: 0.4rem;
  margin-right: 0.5rem;
  font-weight: bold
}
.price_area {
  display: flex;
  align-items: center;
  .quote {
    .price {
      font-size: 0.4rem;
      font-weight: bold;
    }
    .price.green{
      &::after{
        content:'↓';
        color: green;
        position: relative;
        right:-.1rem;
      }
    }
    .price.red{
      &::after{
        content:'↑';
        color: red;
        position: relative;
        right:-.1rem;
      }
    }
    .ampulte {
      font-size: 0;
    }
    .ampulte.red{
      color: red;
    }
    .ampulte.green{
      color: green;
    }
    span {
      font-size: 0.24rem;
      margin-right: .2rem;
    }
  }
}
.time_choice {
  border: 0.02rem solid #ddd;
  height: 4.8rem;
  position: relative;
  z-index: 10;
  ul {
    display: flex;
    justify-content: space-around;
    border-bottom: 0.02rem solid #ddd;
    position: relative;
    z-index: 10;
    li {
      font-size: 0.24rem;
      padding: 0.2rem 0;
    }
    li.active {
      color: #0096dc;
    }
  }
}
</style>